import { determineTranscode } from '@/components/common/BatchUpload/common/utils';
import { ossCopy } from '@/utils/fileUtil';
import request from '@/utils/request';

import { ApiResult } from '../';

interface EventResultType {
  engineCode: string;
  engineMessage: string;
  taskState: number;
  extraEventResult: string;
  businessId: number;
  fileUrl: string;
  duration: number;
}

/**
 * 查询Event结果
 * state 0-已成功提交给引擎，1-未能成功发给引擎，2-引擎回调返回成功，3-引擎回调返回失败,8-任务已取消
 */
export const fetchEventResult = async (
  businessId: string,
): Promise<ApiResult<EventResultType>> => {
  const res = await request('/api/rest/dlt/cloud/make/queryResult', {
    method: 'POST',
    data: { businessId },
  });
  return res;
};

// 视频转码
export const videoTranscode = (codecType: 'h265' | 'h264' = 'h265') => {
  let stop: boolean = false;
  return {
    handler: () => {
      stop = true;
    },
    fn: async (
      videoUrl: string,
      needTransCode: boolean = false,
    ): Promise<{ videoUrl: string; coverUrl: string }> => {
      return new Promise(async (resolve, reject) => {
        const doTranscode = async (codec: 'h265' | 'h264') => {
          const event = {
            process_event_type: 190,
            video_transcoding2_event: {
              video_url: videoUrl,
              type: 0,
              video_codec_type: codec === 'h265' ? 0 : 1,
            },
          };

          const task = await request('/api/rest/dlt/cloud/simple/make', {
            method: 'POST',
            data: {
              event,
              datas: [],
            },
          });

          if (!task?.success) return reject('transcoding failed');

          const businessId = task.data.businessId;
          const fn = async () => {
            const res = await fetchEventResult(businessId);

            if (!res?.data) {
              return reject('transcoding failed');
            }

            let { taskState } = res.data;
            if (taskState !== 0) {
              if (taskState === 2) {
                try {
                  const { extraEventResult } = res.data;
                  const { video_transcode2_event_result } = JSON.parse(extraEventResult);
                  const { output_video_url, output_cover_url } =
                    video_transcode2_event_result;

                  // 判断265编码下是否需要再次转码为264
                  if (codec === 'h265') {
                    const needTarnscodeH264 = await determineTranscode(output_video_url);
                    if (needTarnscodeH264) {
                      return await doTranscode('h264');
                    }
                  }

                  if (needTransCode) {
                    // 转码后需要转存一下
                    const copyVideoUrl = output_video_url
                      ? await ossCopy(output_video_url)
                      : output_video_url;
                    const copyCoverUrl = output_cover_url
                      ? await ossCopy(output_cover_url)
                      : output_cover_url;

                    return resolve({
                      videoUrl: copyVideoUrl,
                      coverUrl: copyCoverUrl,
                    });
                  } else {
                    return resolve({
                      videoUrl: output_video_url,
                      coverUrl: output_cover_url,
                    });
                  }
                } catch (e) {
                  return reject('transcoding failed');
                }
              } else {
                return reject('transcoding failed');
              }
            }

            if (!stop) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              await fn();
            } else {
              reject('transcoding canceled');
            }
          };

          await fn();
        };

        await doTranscode(codecType);
      });
    },
  };
};
